import React, { Fragment } from 'react';
import { createGlobalStyle } from 'styled-components';
import TrackingProvider, { logPageView, initSessionForRouting } from "./src/components/Tracking/index";
import { getCookie, Cookie } from "./src/utils/cookie";

import "@fontsource/poppins/latin-400.css";
// import "@fontsource/poppins/latin-500.css"
// import "@fontsource/poppins/latin-600.css"
import "@fontsource/poppins/latin-700.css"

// require("dotenv").config({
//   path: `.env.${process.env.NODE_ENV}`,
// })

// console.log("GATSBY BROWSER");
// console.log("ENVIRONMENT1#$", process.env.NODE_ENV);

const GlobalStyle = createGlobalStyle`
  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, sans-serif;
  }

  html,
  body {
    padding: 0;
    margin: 0;
    height: 100%;
    font-weight: 400;
    color: #000;
    background: #fff;
  }

  body {
    position: relative;
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, sans-serif;
    font-size: 14px;
  }

  input,
  textarea,
  select {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, sans-serif;
    -webkit-appearance: none;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Poppins', -apple-system, BlinkMacSystemFont, sans-serif;
  }

  label {
    font-family: 'Poppins';
    color: #000;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  a {
    text-decoration: none;
  }

  button {
    border: none;
  }

  button,
  button:focus {
    outline: none;
    cursor: pointer;
    font-family: inherit;
  }

  :focus {
    outline: none;
  }
`;

export const wrapPageElement = ({ element }) => (
  <Fragment>
    <GlobalStyle />
    {element}
  </Fragment>
)

export const wrapRootElement = ({ element }) => (
  <TrackingProvider>{element}</TrackingProvider>
)


export const onRouteUpdate = ({ location, prevLocation }) => {
  if (!getCookie(Cookie.UserTracking)) {
    initSessionForRouting();
    return
  }
  logPageView(location.pathname);

  // experimental
  // if (process.env.NODE_ENV !== 'production') {
  //   console.log("NOT PRODUCTION");
  //   console.log("ON ROUTE UPDATE NOT RUNNING");
  //   return null;
  // } else {
  //   console.log("ON ROUTE");
  //   try {
  //     const pagePath = location ? location.pathname + location.search + location.hash : undefined;
  //     setTimeout(() => {
  //       if (typeof gtag !== 'undefined' && typeof gtag === 'function') {
  //         gtag('event', 'page_view', { page_path: pagePath });
  //       }
  //     }, 100);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
}

//</>

// export function onRouteUpdate({ location }) {
//   console.log(location);
//   // wrap inside a timeout to ensure the title has properly been changed
//   if (window.ga) {
//     setTimeout(() => {
//       window.ga('send', 'pageview');
//     }, 50)
//   }
// }
